import { get, post } from '../axios'

// 新增Or更新多语言KEY
export function i18n_key_addOrUpdate_post(map, option) {
  return post(
    `${process.env.VUE_APP_I18N}/i18n/key/addOrUpdate`,
    map,
    option
  ).then(response => response)
}

// 多语言KEY列表
export function i18n_key_list_post(map, option) {
  return post(
    `${process.env.VUE_APP_I18N}/i18n/key/list?pageNum=${map.pageNum}&pageSize=${map.pageSize}`,
    map,
    option
  ).then(response => response)
}

// 多语言文案列表
export function i18n_value_list_post(map, option) {
  return post(
    `${process.env.VUE_APP_I18N}/i18n/value/list?pageNum=${map.pageNum}&pageSize=${map.pageSize}`,
    map,
    option
  ).then(response => response)
}

// 多语言文案更新
export function i18n_value_update_post(map, option) {
  return post(
    `${process.env.VUE_APP_I18N}/i18n/value/update`,
    map,
    option
  ).then(response => response)
}

// 文件上传
export function i18n_upload_post(map, option) {
  return post(`${process.env.VUE_APP_I18N}/i18n/upload`, map, option).then(
    response => response
  )
}
// 所有站点信息
export function site_all(map, option) {
  return get(`${process.env.VUE_APP_I18N}/mdm/site/all`, map, option).then(
    response => response
  )
}
// key值导入
export function import_all_post(map, option) {
  return post(`${process.env.VUE_APP_I18N}/i18n/key/import`, map, option).then(
    response => response
  )
}

// key值导出
export function export_all_post(map, option) {
  return post(
    `${process.env.VUE_APP_I18N}/i18n/key/exportKey`,
    map,
    option
  ).then(response => response)
}

// 未配置value值的数量
export function no_configuration_count(map, option) {
  return post(
    `${process.env.VUE_APP_I18N}/i18n/value/noValueCount`,
    map,
    option
  ).then(response => response)
}
